<template>
  <child-container
      :container-name="containerName"
      :container-title="title"
      overflow-val="visible"
      ref="container"
      v-on:container-hidden="containerHidden"
      v-on:container-shown="containerShown"
  >
    <multiple-forms-component
        :form-rows="formRows"
        :initial-form-data="initialFormData"
        :buttons="buttons"
        :form-width="formWidth"
        :viewport-i-d="viewportID"
        :client-i-d="clientID"
        :allow-new="allowNow"
        ref="form"
    >
    </multiple-forms-component>
  </child-container>
</template>

<script setup>
import { reactive, onMounted, watch, ref, nextTick, getCurrentInstance, onBeforeMount } from 'vue';
import ChildContainer from './../ChildContainer/ChildContainer.vue';
import * as oxygenUtil from './../OxygenUtil/oxygenutil.js';
import MultipleFormsComponent from './../MultipleFormsComponent/MultipleFormsComponent.vue';

let props = defineProps({
  allowNow: Boolean,
  title: String,
  viewportID: String,
  clientID: String,
  formRows: Array,
  initialFormData: {
    type: Array,
    default: () => []
  },
  buttons: {
    type: Array,
    default: () => []
  },
  formWidth: {
    type: Number,
    default: 400
  }
});

let form = ref(null), formInstance = ref(null), formData = ref([]), containerName = `container${oxygenUtil.getUUID()}`, container = ref(null);



async function containerShown() {
  if(form.value.formInstance) {
    form.value.formInstance.destructor();
  }

  await nextTick();
  await form.value.initializeForm();
  formInstance.value = form.value.formInstance;
  formData.value = form.value.formData;
}





function containerHidden() {
  form.value.formInstance.destructor();
}
onMounted(()=>{

});

onBeforeMount(()=>{
  //initialFormProperties();
})

function show() {
  container.value.show();
}

function hide() {
  container.value.hide();
}

function showContainerAlignedToElement(...args) {
  container.value.showModalAlignedToElement(...args)
}

function showContainerAlignedToElementInViewport(...args) {
  container.value.showContainerAlignedToElementInViewport(...args)
}

/**
 * Form-related items
 */


defineExpose({
  show,
  hide,
  showContainerAlignedToElement,
  showContainerAlignedToElementInViewport,
  formInstance,
  formData
});
</script>

<style>
/*@import url('/simplia/dist/css/suite.min.css');*/
</style>